import React from "react";
import Axis from "./components/Axis.js";
import LineGroup from "./components/Line.js";

import * as d3 from "d3";

const dimensions = {
  width: 600,
  height: 300,
  margin: { block: 30, inline: 50 }
};

export default function MultiLineChart({players = new Map(), colors = {}, data = [], dimensions}) {

  const svgRef = React.useRef(null);
  const { width, height, margin } = dimensions;
  const svgWidth = margin.inline + width + margin.inline;
  const svgHeight = margin.block + height + margin.block;

  const xScale = d3.scaleTime()
                   .range([0, width])
                   .domain(
                     [new Date(2004, 0), new Date()]
                   ).nice();

  const yScale = d3.scaleLinear()
                   .range([height, 0])
                   .domain([0, 3000]);

  return <svg viewBox={`0 0 ${svgWidth} ${svgHeight}`} preserveAspectRatio={"xMinYMin meet"}>
    <g transform={`translate(${margin.inline},${margin.block})`}>
      <Axis
        type="left"
        ticks={5}
        tickSize={-width}
        scale={yScale}
      />
      <Axis 
        type="bottom"
        ticks={10}
        tickSize={-height}
        scale={xScale}
        transform={`translate(0, ${height})`}
      />
      <LineGroup
        key="all"
        data={data}
        xScale={xScale}
        yScale={yScale}
        getColor={player => "rgba(0, 0, 0, 0.02)"}
      />
      {Array.from(players.keys()).map(playerName =>
        <LineGroup
          key={playerName}
          data={data.filter(player => player.player == playerName)}
          xScale={xScale}
          yScale={yScale}
          getColor={player => (players.get(player) || "rgba(0, 0, 0, 1)")}
        />
      )}
    </g>
  </svg>;
}
